import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { RateItem } from '../../types';
import { exchangeRatesApi } from '../services';

export interface RateSidepanelState {
  rate?: RateItem;
  panelIsOpen: boolean;
  rateHistory?: RateItem[];
  pagination?: Pagination;
  expandedRateHistoryId?: string;
}

const initialState: RateSidepanelState = {
  panelIsOpen: false,
};

export const rateSidepanelSlice = createSlice({
  name: 'rateSidepanel',
  initialState,
  reducers: {
    setRateHistory: (
      state,
      action: PayloadAction<{
        edges: { node: RateItem }[];
        pageInfo: Pagination;
      }>,
    ) => {
      state.rateHistory = action.payload.edges?.map((item) => item.node);
      state.pagination = action.payload.pageInfo;
    },
    setExpandedRateHistoryId: (state, action: PayloadAction<string>) => {
      state.expandedRateHistoryId = action.payload;
    },
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
    clearRateSidepanelState: (state) => {
      state.rate = undefined;
      state.panelIsOpen = false;
      state.rateHistory = undefined;
      state.expandedRateHistoryId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exchangeRatesApi.endpoints.getRate.matchFulfilled,
      (state, action: PayloadAction<{ data: RateItem }>) => {
        state.rate = action.payload.data;
      },
    );
    builder.addMatcher(
      exchangeRatesApi.endpoints.updateRate.matchFulfilled,
      (state, action: PayloadAction<{ data: RateItem }>) => {
        state.rate = action.payload.data;
      },
    );
    builder.addMatcher(
      exchangeRatesApi.endpoints.getExchangePairRates.matchFulfilled,
      (state, action: PayloadAction<Response<RateItem>>) => {
        state.rateHistory = action.payload.data.edges.map((item) => item.node);
        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      exchangeRatesApi.endpoints.getRateHistoryDetails.matchFulfilled,
      (
        state,
        action: PayloadAction<{ data: RateItem }> & {
          meta: {
            arg: {
              originalArgs: string;
            };
          };
        },
      ) => {
        if (state.rateHistory) {
          const nextRateHistory = state.rateHistory?.map((item) => {
            const result = { ...item };

            if (result.id === action.meta.arg.originalArgs) {
              result.logs = action.payload.data.logs;
            }

            return result;
          });

          state.rateHistory = nextRateHistory;
        }
      },
    );
  },
});

export const {
  changePanelState,
  clearRateSidepanelState,
  setRateHistory,
  setExpandedRateHistoryId,
} = rateSidepanelSlice.actions;

export default rateSidepanelSlice.reducer;
